import { useCallback } from 'react';
import { apiCreatePopupRead } from '@/actions/PopupActions';
export const usePopupEvent = (dispatch, event) => useCallback(() => {
    dispatch(apiCreatePopupRead(event, {}));
}, [dispatch, event]);
export default usePopupEvent;
